import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "client-app",
  class: "app"
}
const _hoisted_2 = {
  key: 0,
  class: "p-4"
}
const _hoisted_3 = {
  key: 1,
  class: "p-4"
}
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  key: 2,
  class: "p-4"
}
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "answer-footer-mobile"
}
const _hoisted_8 = { class: "d-flex align-center ga-2" }
const _hoisted_9 = { class: "text-white text-body-2 font-weight-medium" }

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { checkMobile } from '../utils/utils'
import Header from './organisms/Header.vue'
import Footer from './organisms/Footer.vue'
import { ROUTER_NAME } from '../router'
import { LETTER_FORMAT } from '../utils/constants'
import ChartProgress from './atoms_molecules/ChartProgress.vue'
import { makeChannel } from '../../../action_cable/cable'
import { userState } from '../stores/user'
import { notificationState } from '../stores/notification'
import { examState } from '../stores/exam'
import { footerState } from '../stores/footer'
import { examTestState } from '../stores/exam_test'
import { snackBarState } from '../stores/snackbar'
import { menuState } from '../stores/menu'
import { examResultState } from '../stores/exam_result'
import { subscriptionState } from '../stores/subscription'
import { examMyState } from '../stores/exam_my'
import { routerKeyState } from '../stores/router_key'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const transitionName = ref('fade')
const mobile = ref(false)
const show = ref(false)

const routerKey = computed(() => {
  return `${String(route.name || 'default')}-${routerKeyState.key}`
})

const user = computed(() => userState.user)
const footerRender = computed(() => footerState.dataRender)
const snackbar = computed(() => snackBarState.snackbar)

const unconfirmedEmail = computed(() => {
  return user.value && user.value.unconfirmedEmail
})

const needsEmailConfirmation = computed(() => {
  return user.value && user.value.guestType === 'lazy_signup'
})

const guestWarning = computed(() => {
  return (user.value && user.value.isGuest && route && route.name === ROUTER_NAME.HOME)
})

const isOnBoarding = computed(() => {
  return route && route.name === ROUTER_NAME.ON_BOARDING
})

const exam = computed(() => examResultState.examResult)

const answersFlowQuestion = computed(() => {
  if (!exam.value || !exam.value.userExam) return []
  return exam.value.answersFlowQuestion(exam.value.userExam)
})

const isMeeting = computed(() => {
  return location.pathname.includes('meeting')
})

const isActivityPage = computed(() => {
  return route.name === ROUTER_NAME.ACTIVITY_LIST
})

const watchUser = () => {
  if (user.value && user.value.userOnboard && route && router && route.name !== ROUTER_NAME.ON_BOARDING) {
    router.push({
      name: ROUTER_NAME.ON_BOARDING
    })
  }
}

const closeSnackbar = () => {
  show.value = false
  snackBarState.setDefaultSnackbar()
}

// Watch user changes
watch(user, () => {
  watchUser()
})

// Watch snackbar changes
watch(snackbar, (val) => {
  show.value = val.open
})

// Watch route changes
watch(() => route.fullPath, (newPath, oldPath) => {
  const oldRouteName = route.name

  // キャッシュ防ぐために、Examじゃないページに移動したら、キャッシュを消す
  if (!([
    ROUTER_NAME.EXAM_SHOW,
    ROUTER_NAME.QUESTION,
    ROUTER_NAME.EXAM_QUESTION_LIST,
    ROUTER_NAME.EXAM_RESULT,
    ROUTER_NAME.ANSWER_RESULT_DETAIL,
  ] as string[]).includes(route.name as string)) {
    examTestState.reset()
    examResultState.reset()
  }

  watchUser()
})

let notificationChannel: ReturnType<typeof makeChannel> | null = null

onMounted(() => {
  userState.getUser()
  menuState.getMenus()
  notificationState.getNotification({ checkNotification: false })
  if (!route || route.name != ROUTER_NAME.EXAM_RECOMMENDATION_LIST) {
    examState.getRecommendationList()
  }
  mobile.value = checkMobile()

  notificationChannel = makeChannel(
    'NotificationChannel',
    (data) => {
      // Broadcast already carries unread_count, so just update the badge
      // instead of re-fetching the whole list on every push (avoids request storms).
      notificationState.unread = data.unread_count
    },
    () => {
      notificationChannel?.send({
        action: 'follow'
      })
    }
  )

  if (router) {
    router.beforeEach((to, from, next) => {
      let transName = to.meta.transitionName || from.meta.transitionName

      if (transName === 'slide') {
        transName = (to.meta.index as number) < (from.meta.index as number) ? 'slide-right' : 'slide-left'
      }

      transitionName.value = (transName as string) || 'fade'
      next()
    })
  }
})

onBeforeUnmount(() => {
  notificationChannel?.unsubscribe()
  notificationChannel = null
})

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(Header),
        _createVNode(_component_v_main, { class: "bg-gray" }, {
          default: _withCtx(() => [
            (unconfirmedEmail.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_alert, {
                    type: "error",
                    class: "xs12 mb-0"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("p", { class: "mb-0" }, "【注意】ユーザー編集はまだ終わっていません。", -1 /* CACHED */),
                      _createElementVNode("p", { class: "mb-0" }, "確認メールを送信しましたので、メール内のリンクをクリックして変更を有効にしてください。", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]))
              : (needsEmailConfirmation.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_v_alert, {
                      type: "warning",
                      class: "xs12 mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_4, [
                          _cache[2] || (_cache[2] = _createTextVNode("本登録が完了していません。", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(user.value.email), 1 /* TEXT */),
                          _cache[3] || (_cache[3] = _createTextVNode(" に届いた確認メールのリンクをクリックして登録を完了してください。", -1 /* CACHED */))
                        ]),
                        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-0" }, [
                          _createTextVNode("届いていない場合は"),
                          _createElementVNode("a", {
                            href: "/users/confirmation/new",
                            class: "ml-1"
                          }, "確認メールを再送信"),
                          _createTextVNode("できます。")
                        ], -1 /* CACHED */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : (guestWarning.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_v_alert, {
                        type: "warning",
                        class: "xs12 mb-0"
                      }, {
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mb-0" }, "あなたはゲストユーザーです。ユーザー設定を済ませてください（これを行わないとテスト結果が消えて、次からログインできなくなります）", -1 /* CACHED */)),
                          _createElementVNode("p", _hoisted_6, [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "me-3" }, "ユーザー名、メールアドレス、パスワードの設定を行ってください", -1 /* CACHED */)),
                            _createVNode(_component_router_link, { to: "/classroom/myprofile" }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode("リンク", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]))
                  : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              class: _normalizeClass({ 'p-0': mobile.value })
            }, [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  _createVNode(_Transition, {
                    name: transitionName.value,
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: routerKey.value }))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["name"])
                ]),
                _: 1 /* STABLE */
              }),
              (
              mobile.value &&
                (_ctx.$route.name == _unref(ROUTER_NAME).QUESTION || _ctx.$route.name == _unref(ROUTER_NAME).QUESTION_HEADER) &&
                exam.value &&
                answersFlowQuestion.value
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(), _createBlock(ChartProgress, {
                      size: 160,
                      series: [(answersFlowQuestion.value.length * 100) / exam.value.questionsIgnoreDescription.length],
                      labelColor: '#2699fb',
                      label: answersFlowQuestion.value.length + '/' + exam.value.questionsIgnoreDescription.length,
                      subLabel: _ctx.$t('question.question', { format: _unref(LETTER_FORMAT).UPTITLECASE }),
                      chartColor: '#2699fb',
                      key: answersFlowQuestion.value.length / exam.value.questionsIgnoreDescription.length
                    }, null, 8 /* PROPS */, ["series", "label", "subLabel"]))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_snackbar, {
          modelValue: show.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
          location: "top right",
          timeout: 3000,
          color: snackbar.value.color,
          rounded: "lg",
          "min-width": "280"
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              icon: "",
              variant: "text",
              color: "white",
              size: "small",
              onClick: closeSnackbar
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-close", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(snackbar.value.color === 'error' ? 'mdi-alert-circle' : snackbar.value.color === 'success' ? 'mdi-check-circle' : 'mdi-information'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_9, _toDisplayString(snackbar.value.text), 1 /* TEXT */)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "color"]),
        _createVNode(Footer, { dataRender: footerRender.value }, null, 8 /* PROPS */, ["dataRender"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})